/**
 * 审计支撑中心路由（V1）
 *
 * Phase 0 阶段：所有业务路由指向通用占位页 _PagePlaceholder.vue。
 * Phase 2-5 落地具体页面时，逐个替换对应 component 引用即可。
 *
 * 文档参考：
 *   prototype/docs/审计支撑增强包-PRD/v1.0/
 *     - 审计支撑增强包V1-原型实施计划.md
 *     - 页面结构与字段清单.md
 */

const PagePlaceholder = () => import('@/views/audit-support/_PagePlaceholder.vue')
const DesignPreview = () => import('@/views/audit-support/_DesignPreview.vue')

// Phase 2 已交付的页面
const VerificationBatchList = () => import('@/views/audit-support/verification/BatchList.vue')
const VerificationCrossSourceDiff = () => import('@/views/audit-support/verification/CrossSourceDiff.vue')
const VerificationSummary = () => import('@/views/audit-support/verification/VerificationSummary.vue')

// Phase 3 已交付的页面
const RiskObjectList = () => import('@/views/audit-support/risk-identification/RiskObjectList.vue')
const RiskObjectDetail = () => import('@/views/audit-support/risk-identification/RiskObjectDetail.vue')
const RiskRuleConfig = () => import('@/views/audit-support/risk-identification/RiskRuleConfig.vue')

// Phase 4 已交付的页面
const IssueList = () => import('@/views/audit-support/issue-check/IssueList.vue')
const IssueDetail = () => import('@/views/audit-support/issue-check/IssueDetail.vue')
const EvidenceAndLog = () => import('@/views/audit-support/issue-check/EvidenceAndLog.vue')

// Phase 5 已交付的页面
const Workbench = () => import('@/views/audit-support/workbench/index.vue')
const ReportCenter = () => import('@/views/audit-support/audit-report/ReportCenter.vue')
const ReportPreview = () => import('@/views/audit-support/audit-report/ReportPreview.vue')

const auditSupportRoutes = [
  // ─── 审计支撑工作台 ───────────────────────────────────────────
  {
    path: '/audit-support/workbench',
    name: 'AuditSupport.Workbench',
    component: Workbench,
    meta: { title: '审计支撑工作台', requiresAuth: true, phase: 'Phase 5' }
  },

  // ─── 数据核验中心 ──────────────────────────────────────────────
  {
    path: '/audit-support/verification/batch-list',
    name: 'AuditSupport.Verification.BatchList',
    component: VerificationBatchList,
    meta: { title: '批次核验列表', requiresAuth: true, phase: 'Phase 2' }
  },
  {
    path: '/audit-support/verification/cross-source-diff/:leftBatchId/:rightBatchId',
    name: 'AuditSupport.Verification.CrossSourceDiff',
    component: VerificationCrossSourceDiff,
    meta: { title: '差异核验详情', requiresAuth: true, phase: 'Phase 2' }
  },
  {
    path: '/audit-support/verification/summary/:batchId',
    name: 'AuditSupport.Verification.Summary',
    component: VerificationSummary,
    meta: { title: '核验摘要', requiresAuth: true, phase: 'Phase 2' }
  },

  // ─── 风险识别中心 ──────────────────────────────────────────────
  {
    path: '/audit-support/risk/object-list',
    name: 'AuditSupport.Risk.ObjectList',
    component: RiskObjectList,
    meta: { title: '风险对象列表', requiresAuth: true, phase: 'Phase 3' }
  },
  {
    path: '/audit-support/risk/object/:id',
    name: 'AuditSupport.Risk.ObjectDetail',
    component: RiskObjectDetail,
    meta: { title: '风险对象详情', requiresAuth: true, phase: 'Phase 3' }
  },
  {
    path: '/audit-support/risk/rule-config',
    name: 'AuditSupport.Risk.RuleConfig',
    component: RiskRuleConfig,
    meta: { title: '风险规则配置', requiresAuth: true, phase: 'Phase 3' }
  },

  // ─── 问题核查中心 ──────────────────────────────────────────────
  {
    path: '/audit-support/issue/list',
    name: 'AuditSupport.Issue.List',
    component: IssueList,
    meta: { title: '问题台账', requiresAuth: true, phase: 'Phase 4' }
  },
  {
    path: '/audit-support/issue/detail/:id',
    name: 'AuditSupport.Issue.Detail',
    component: IssueDetail,
    meta: { title: '问题详情', requiresAuth: true, phase: 'Phase 4' }
  },
  {
    path: '/audit-support/issue/evidence/:id',
    name: 'AuditSupport.Issue.Evidence',
    component: EvidenceAndLog,
    meta: { title: '证据与日志', requiresAuth: true, phase: 'Phase 4' }
  },

  // ─── 审计报告中心 ──────────────────────────────────────────────
  {
    path: '/audit-support/report/center',
    name: 'AuditSupport.Report.Center',
    component: ReportCenter,
    meta: { title: '审计报告中心', requiresAuth: true, phase: 'Phase 5' }
  },
  {
    path: '/audit-support/report/preview/:id',
    name: 'AuditSupport.Report.Preview',
    component: ReportPreview,
    meta: { title: '报告预览', requiresAuth: true, phase: 'Phase 5' }
  },

  // ─── 隐藏:设计系统预览（Phase 6 收口时删除）────────────────────
  {
    path: '/audit-support/_design-preview',
    name: 'AuditSupport._DesignPreview',
    component: DesignPreview,
    meta: { title: '设计系统预览', requiresAuth: true, hidden: true, phase: 'Phase 0（临时）' }
  }
]

export default auditSupportRoutes
